import app from '../../../api/app'
const state = {
  appId: '',
  treeData: []
}

const actions = {
  applicationLinkTree({ commit }, appId) {
    return new Promise((resolve, reject) => {
      app.applicationLinkTree(appId).then(res => {
        if (false === res.result || false === res.success) {
          resolve(res)
          return;
        }
        commit('applicationLinkTree',{appId:appId,data:res.result})
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  getApplicationLinkTree: function (state, getters) {
    return function () {
      return state.treeData
    }
  }
}

const mutations = {
  ['applicationLinkTree'](state, data) {
    state.appId = data.appId;
    state.treeData = data.data;
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/common/vuex/modules/app/applicationLinkTree.js